// extracted by mini-css-extract-plugin
export default {"btn":"Btn_btn__jiT5z","isActive":"Btn_isActive__20CJi"};